import React, {useEffect, useState} from "react";
import { Grid} from "@material-ui/core";
import {onChangeInput} from "../../../services/utils";
import {InputRow,Fieldset} from "../../../components";
import {otherSectorsOption} from "../../../environment";
import Button from "@material-ui/core/Button";
import HttpService from "../../../services/http.service";

const UserProfileForm = (props) => {
  const {
    state,
    setState,
    updateUser,
  } = props;
  const {values, errors} = state;
  const [countries, setCountries] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [cityList, setCityList] = useState([]);

  useEffect(() => {
    HttpService.get("marketplace/countriesList").then((res) => {
      if (res) {
        let list = res.data;
        let len = (list && list.length) || 0;
        const array = [];
        for (let i = 0; i < len; i++) {
          array.push({text: list[i].countryName, value: list[i].countryID});
        }
        setCountries(array);
      }
    });
  }, []);
  useEffect(() => {
    // let country = "UAE"
    let country = values.country;
    if (country) {
      HttpService.get(`marketplace/statesByCountry/${country}`).then((res) => {
        if (res) {
          let list = res.data;
          let len = (list && list.length) || 0;
          const array = [];
          for (let i = 0; i < len; i++) {
            array.push({text: list[i].stateName, value: list[i].stateID});
          }
          setStateList(array);
        }
      });
    }
  }, [values.country]);
  useEffect(() => {
    // let state = "5347"
    let states = values.state;
    // setCityList([])
    if (states) {
      HttpService.get(`marketplace/cityByStates/${states}`).then((res) => {
        if (res) {
          let list = res.data;
          let len = (list && list.length) || 0;
          const array = [];
          for (let i = 0; i < len; i++) {
            array.push({text: list[i].cityName, value: list[i].cityID});
          }
          console.log(array);
          setCityList(array);
        }
      });
    }
  }, [values.state]);

  return (
    // <Card className="pb-20  mt-20">
      <Grid container >
        <Grid lg={12} md={12} className='mt-10 '>
        <Fieldset title={'Please update your business details'} children={
          <>

          <InputRow
            types={[
              {
                value: values.agriBusinessName,
                error: errors.agriBusinessName,
                id: "agriBusinessName",
                label: "Business name",
              },
              {
                value: values.agriBusinessPoc,
                error: errors.agriBusinessPoc,
                id: "agriBusinessPoc",
                label: "point of Contract",
              },
              {
                value: values.agriBusinessWebsite,
                error: errors.agriBusinessWebsite,
                label: "website",
                id: "agriBusinessWebsite",
              },
              {
                value: values.agriBusinessPocEmail,
                error: errors.agriBusinessPocEmail,
                label: "email",
                id: "agriBusinessPocEmail",
                endAdornment: {
                  text: "verify",
                  onClick: () => {
                    props.verification("email");
                  },
                },
              },
              {
                value: values.agriBusinessPocContact,
                error: errors.agriBusinessPocContact,
                label: "mobile",
                id: "agriBusinessPocContact",
                endAdornment: {
                  text: "verify",
                  onClick: () => {
                    props.verification("number");
                  },
                },
              },
              {
                type: "select",
                value: values.otherAreas,
                error: errors.otherAreas,
                id: "otherAreas",
                label: "other Sectors",
                dropdownList: otherSectorsOption,
              },
              // {value: values.longitude, error: errors.longitude, label: "longitude",},
              // {value: values.latitude, error: errors.latitude, label: "latitude",},
              {
                type: "select",
                value: values.country,
                error: errors.country,
                label: "country",
                dropdownList: countries,
              },
              {
                type: "select",
                value: values.state,
                error: errors.state,
                label: "state",
                dropdownList: stateList,
              },
              {
                type: "select",
                value: values.cityId,
                error: errors.cityId,
                label: "city",
                id: "cityId",
                dropdownList: cityList,
              },

              {
                type: "file",
                id: "iCard1",
                value: values.idCard1?.name ?? "",
                error: errors.idCard1,
                label: "id Card (front side)",
                accept: 'image/*'
              },
              {
                type: "file",
                value: values.idCard2?.name ?? "",
                error: errors.idCard2,
                label: "id Card (back side)",
                id: "iCard2",
                accept: 'image/*'
              },
              {
                type: "file",
                value: values.passport?.name ?? "",
                error: errors.passport,
                label: "passport",
                accept: 'image/*'
              },
            ]}
            onChangeInput={(value, key) =>
              onChangeInput(value, key, state, setState)
            }
            numOfInputPerRow={3}
          />
            <Grid container className="mt-30  ml-10   ">
              <Button
                type="submit"
                variant="contained"
                color="primary"
                onClick={(e) => updateUser(e)}
              >
                Save business details
              </Button>
            </Grid>
          </>
        }/>
        </Grid>


      </Grid>
    // </Card>
  );
};

export default UserProfileForm;
